import React, { useContext } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import IBTooltip from '@totem/components/common/helpTooltips/IBTooltip';
import SoftwareContext from '@totem/components/software/software_report/softwareContext';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';

const styles = {
  button: {
    marginRight: '20px',
  },
};

export interface Props {
  isPrimary?: boolean;
}
const WhereFoundButton = ({ isPrimary }: Props) => {
  const { userProfile } = useContext(UserProfileContext);
  const { selectedPackages, action, onAction } = useContext(SoftwareContext);
  const canView = permissions.internal.hasPermissions(userProfile);

  return (
    <IBTooltip content={permissions.internal.tooltip}>
      <Button
        style={styles.button}
        icon={<SearchOutlined />}
        type={
          typeof isPrimary !== 'undefined' && isPrimary ? 'primary' : 'default'
        }
        disabled={
          !canView ||
          action === 'where-found' ||
          typeof selectedPackages === 'undefined' ||
          selectedPackages === null ||
          selectedPackages.length < 1
        }
        onClick={() => onAction('where-found', null)}
      >
        Where Found
      </Button>
    </IBTooltip>
  );
};

export default WhereFoundButton;
